/**
 * ============================================================================
 * DOGSTER BARF · Guardián de cantidad mínima en el carrito (v2)
 * ----------------------------------------------------------------------------
 * CORRECCIÓN respecto a la v1: la v1 corregía la cantidad llamando a
 * /cart/change.js DESPUÉS de que el cliente cambiaba el campo — pero el
 * propio tema (Dawn) también escucha ese mismo cambio y envía SU PROPIA
 * actualización al mismo tiempo. Como las dos peticiones viajan en
 * paralelo, a veces la del tema llegaba después y dejaba la cantidad
 * inválida, aunque el aviso ya se hubiera mostrado (carrera de eventos).
 *
 * v2 ya no corre una carrera contra el tema: ANTES de que el cliente
 * pueda cambiar algo, este script ya sabe (de antemano, en segundo
 * plano) qué líneas del carrito tienen mínimo y cuál es — y si el
 * cliente escribe un número menor, lo corrige en el campo al instante,
 * de forma síncrona, antes de que el propio tema lea ese valor para
 * enviarlo. Así el tema termina enviando la cantidad ya corregida, sin
 * necesidad de pelear con él ni de recargar la página.
 *
 * Funciona en CUALQUIER carrito de Shopify (cajón lateral, página
 * /cart, notificación emergente) sin tocar la estructura HTML del
 * tema: identifica las líneas protegidas por la propiedad oculta
 * "_dogster_min_qty" que la calculadora ya agrega — no hay que
 * mantener ninguna lista de productos aquí.
 *
 * INSTALACIÓN: se carga en TODAS las páginas, en layout/theme.liquid,
 * justo antes de </body>:
 *
 *   {{ 'barf-cart-min-qty-guard.js' | asset_url | script_tag }}
 * ============================================================================
 */
(function () {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const NOTICE_CLASS = 'barf-min-qty-notice';
  let priming = false;

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  // Recorre TODOS los inputs de cantidad visibles en la página (cajón,
  // página /cart, notificación) y les marca data-min-qty según la línea
  // de /cart.js a la que correspondan (por el id "Quantity-N" que Dawn
  // usa, donde N es el índice 1-based de la línea). No cambia nada
  // visualmente — solo deja el dato listo para cuando el cliente edite.
  function prime() {
    if (priming) return;
    priming = true;
    fetchCart()
      .then((cart) => {
        document.querySelectorAll('input[type="number"][id]').forEach((input) => {
          const match = input.id.match(/Quantity-(\d+)/);
          if (!match) return;
          const line = cart.items[parseInt(match[1], 10) - 1];
          const minQty = line && parseInt(line.properties && line.properties['_dogster_min_qty'], 10);
          if (minQty) {
            input.dataset.minQty = String(minQty);
          } else {
            delete input.dataset.minQty;
          }
        });
      })
      .finally(() => { priming = false; });
  }

  function showNotice(inputEl, message) {
    const container = inputEl.parentElement || inputEl;
    const existing = container.querySelector('.' + NOTICE_CLASS);
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.className = NOTICE_CLASS;
    el.setAttribute('role', 'alert');
    el.textContent = message;
    el.style.cssText = 'color:#B23A2E;font-size:0.82rem;margin-top:6px;';
    inputEl.insertAdjacentElement('afterend', el);
  }

  // Respaldo SOLO para el caso raro en que el input todavía no tiene
  // data-min-qty (interacción antes de que prime() terminara). Aquí sí
  // hay una corrección después del hecho, con recarga — igual que la v1,
  // pero como último recurso, no como camino normal.
  function correctLineAsync(input, newQty) {
    fetchCart().then((cart) => {
      const match = input.id.match(/Quantity-(\d+)/);
      if (!match) return;
      const line = cart.items[parseInt(match[1], 10) - 1];
      const minQty = line && parseInt(line.properties && line.properties['_dogster_min_qty'], 10);
      if (!minQty || newQty >= minQty) return;
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: minQty })
      }).then(() => {
        showNotice(input, `La cantidad mínima de compra para este producto es de 1 kilo (${minQty} bolsas de 250 g). Ajustamos tu pedido.`);
        setTimeout(() => window.location.reload(), 1400);
      });
    });
  }

  function handleChange(e) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'number') return;
    const newQty = parseInt(input.value, 10);
    if (!newQty || newQty === 0) return; // 0/vacío = quitar del carrito, se permite

    const minQty = parseInt(input.dataset.minQty, 10);
    if (minQty && newQty < minQty) {
      // Corrección SÍNCRONA: ocurre antes de que el propio tema lea el
      // valor del campo para enviar su actualización, así que el tema
      // termina mandando la cantidad ya corregida — sin pelear con él.
      input.value = String(minQty);
      showNotice(input, `La cantidad mínima de compra para este producto es de 1 kilo (${minQty} bolsas de 250 g). Se ajustó automáticamente.`);
      return;
    }
    if (!minQty) {
      // Todavía no se había marcado este input — respaldo async.
      correctLineAsync(input, newQty);
    }
  }

  document.addEventListener('change', handleChange, true);
  // Volver a marcar los inputs justo antes de que el cliente pueda
  // interactuar con ellos (clic o foco), y también al cargar la página
  // y tras cualquier actualización del carrito que dispare nuestro
  // propio evento "cart:refresh".
  document.addEventListener('focusin', (e) => {
    if (e.target instanceof HTMLInputElement && e.target.type === 'number') prime();
  }, true);
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[name="plus"], [name="minus"], .quantity__button')) prime();
  }, true);
  document.addEventListener('cart:refresh', prime);
  document.addEventListener('DOMContentLoaded', prime);
  prime();
  // Red de seguridad liviana por si el tema reconstruye el carrito sin
  // disparar ninguno de los eventos de arriba (p. ej. al abrir el cajón).
  setInterval(prime, 3000);
})();
